import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9 .336a8.063 8.063 0 1 0 0 16.125A8.063 8.063 0 0 0 9 .336M9.563 3.9a.563.563 0 1 0-1.126 0v4.5c0 .31.253.562.563.562h4.5a.562.562 0 1 0 0-1.125H9.562V3.9Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clock"}) } }